/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'checkbox': {
    viewBox: '0 0 24 24',
    data: `<path d="M19,19H5V5H19ZM6,18H18V6H6Z"/>`
  }
})
